import React from "react";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import TextInput, { SelectInput } from "../../../components/TextInput";
import { Address } from "../../../model/address";
import { States } from "../../../constants/states";

interface AddressFormProps {
  address: Address,
  setAddress: (address: Address) => void,
}

const AddressForm = ({ address, setAddress }: AddressFormProps) => {
  const stateItems = States.map((state: { abbreviation: string, name: string }) =>
    <MenuItem key={state.abbreviation} value={state.abbreviation}>{state.name}</MenuItem>
  );
  return (
    <>
      <Grid size={12}>
        <TextInput
          aria-required
          name="address_1"
          label="Street address"
          placeholder="Street Address"
          value={address.address_1}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setAddress({...address, address_1: e.target.value})
          }}
          validators={["required"]}
          errorMessages={["Street address is required"]}
          InputProps={{autoComplete: "address-line1"}}
        />
      </Grid>
      <Grid size={12}>
        <TextInput
          name="address_2"
          label="Apt, Suite, Bldg, Gate code (optional)"
          placeholder="Apt, Suite, Bldg, Gate code (optional)"
          value={address.address_2}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setAddress({...address, address_2: e.target.value })
          }
        />
      </Grid>
      <Grid size={6}>
        <TextInput
          aria-required
          name="city"
          label="City"
          placeholder="City"
          value={address.city}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setAddress({...address, city: e.target.value })
          }
          validators={["required"]}
          errorMessages={["City is required"]}
        />
      </Grid>
      <Grid size={6}>
        <SelectInput
          aria-required
          id="address-state"
          name="state"
          label="State"
          placeholder="State"
          value={address.state}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setAddress({...address, state: e.target.value })
          }
          validators={["required"]}
          errorMessages={["State is required"]}
          items={stateItems}
        />
      </Grid>
      <Grid size={6}>
        <TextInput
          aria-required
          name="zip"
          label="Zip code"
          placeholder="Zip code"
          value={address.zip}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setAddress({...address, zip: e.target.value })
          }}
          type="text"
          validators={["required"]}
          InputProps={{autoComplete: "postal-code"}}
          inputProps={{
            title: "A five-digit Zip code",
            pattern: "\\d{5}",
            onInvalid: (e: React.ChangeEvent<HTMLInputElement>) => {
              e.target.setCustomValidity("Please enter five-digit Zip code");
            },
            onInput: (e: React.ChangeEvent<HTMLInputElement>) => {
              e.target.setCustomValidity("");
            },
          }}
          errorMessages={["Zip code is required"]}
        />
      </Grid>
    </>
  );
};

export default AddressForm;
